<script>
import { Bar, mixins } from 'vue-chartjs'
import { getStyle, hexToRgba } from '@coreui/coreui-pro/dist/js/coreui-utilities'
import { CustomTooltips } from '@coreui/coreui-plugin-chartjs-custom-tooltips'
import { random } from '@/shared/utils'
import moment from 'moment'

export default {
  extends: Bar,
  props: ['height', 'options', 'chartData', 'userData'],
  mixins: [mixins.reactiveProp],

  mounted () {
    const brandSuccess = getStyle('--success') || '#4dbd74'
    const brandInfo = getStyle('--info') || '#20a8d8'
    const brandDanger = getStyle('--danger') || '#f86c6b'

    let d = this.chartData;
    // console.log(d)
    // console.log(this.userData)

    const chartColorScheme = [
      '#20c997',  // teal
      '#17a2b8',  // cyan
      '#6f42c1',  // purple
      '#ffc107',  // brand warning (yellow)
      '#c8ced3',  // gray 300
      '#63c2de',  // brand secondary (light blue)
      '#6610f2',  // indigo
      '#73818f',  // gray 600

      '#52E3B8',  // teal 15% lighter
      '#94EED3',  // teal 30% lighter
      '#158765',  // teal 15% darker

      '#36CEE6',  // cyan 15% lighter
      '#7ADFEE',  // cyan 30% lighter
      '#117A8B',  // cyan 10% darker

      '#9B7CD4',  // purple 15% lighter
      '#C7B6E7',  // purple 30% lighter

      '#FFD454',  // yellow, 15% lighter
      '#FFE7A1',  // yellow, 30% lighter

      '#FF9807',  // orange
      '#FFAD3A',  // orange 10% lighter
    ]

    let xAxisLabels = []
    let chartDatasets = []

    var self = this
    Object.keys(d).forEach(function(uid, userIndex) {

      let user = self.userData.find(member => member.id == uid)

      let userData = {
        label: user.real_name,
        data: []
      }

      // console.log(d[uid])
      Object.keys(d[uid]).forEach(function(epoch) {
        let row = d[uid][epoch]

        // x axis labels.  only do this once
        if(userIndex == 0) {

          xAxisLabels.push(moment.unix(epoch).format('MMM Do hA'))
        }

        userData.data.push(row.channel + row.direct + row.mpim)

      })

      chartDatasets.push(userData)

    })

    this.renderChart({
      labels: xAxisLabels,
      datasets: chartDatasets
    }, 
    // chart options
    {
      tooltips: {
        enabled: false,
        custom: CustomTooltips,
        intersect: true,
        mode: 'index',
        position: 'nearest',
        callbacks: {
          labelColor: function (tooltipItem, chart) {
            return { backgroundColor: chart.data.datasets[tooltipItem.datasetIndex].borderColor }
          }
        }
      },
      maintainAspectRatio: false,
      legend: {
        display: true,
        position: 'bottom'
      },
      scales: {
        xAxes: [{
          stacked: true,
          gridLines: {
            drawOnChartArea: false
          },
          ticks: {
            autoSkip: true,
            maxTicksLimit: 24 // this will need to be dynamic based on time window
          }
          
        }],
        yAxes: [{
          stacked: true,
          ticks: {
            beginAtZero: true,
            precision: 0,
          },
          gridLines: {
            display: true
          }
        }]
      },

      plugins: {
        colorschemes: {
          scheme: chartColorScheme
        }
      }

    })
        
  }
}
</script>
